import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Checkbox } from "../../../components/Checkbox";
import { Textarea } from "../../../components/Textarea";

const PaymentMethods = {
    PIX: 'Pix',
    CREDIT: 'Crédito',
    VOUCHER: 'Voucher',
}
export default class PaymentSwitchesDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            active: true,
            logo: null,
            primaryColor: null,
            secondaryColor: null,
            online_payment: null,
            methodPayment: {}, 
            payment_on_delivery: null,
            descriptions: {},
            paymentsActive: {},
        };
    }

    async componentDidMount() {
            const environmentId = await EnvironmentStorage.getSelectedEnvironment();    
            const switches = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'switches') || {};
            const descriptions = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'payment_descriptions') || {};
            let paymentsActive = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'payments_active') || {};
            const defaultMethods = [ 'VOUCHER', 'CREDIT'];
            defaultMethods.forEach(method => {
                if (paymentsActive[method] === undefined) {
                    paymentsActive[method] = true;
                }
            });
            
            this.setState({
                online_payment: !!switches.online_payment,
                payment_on_delivery: !!switches.payment_on_delivery,
                descriptions: descriptions || {},
                methodPayment: paymentsActive
            });
    }

    updateDescription (field, value) {
        const { descriptions } = this.state;
        this.setState({
            descriptions: {
                ...descriptions,
                [field]: value,
            }
        })
    }
    togglePaymentMethod(field) {
        const { methodPayment } = this.state;
        if (methodPayment[field]) {
            this.setState({
                methodPayment: {
                    ...methodPayment,
                    [field]: false,
                }
            });
        } else {
            this.setState({
                methodPayment: {
                    ...methodPayment,
                    [field]: true,
                }
            });
        }
    }


    async save() {
        const { online_payment, payment_on_delivery, descriptions, methodPayment } = this.state;
    
        this.setState({ loading: true });
        const environmentId = await EnvironmentStorage.getSelectedEnvironment();
        const switches = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'switches') || {};
    
        const paymentsActive = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId,
            'payments_active',
            { payments_active: { ...methodPayment } }
        );
    
        const switchesResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId,
            'switches',
            {
                switches: {
                    ...switches,
                    online_payment,
                    payment_on_delivery,
                }
            }
        );
    
        if (switchesResponse.getErrors([]).length > 0) {
            alert({
                text: switchesResponse.getErrors()[0],
                buttonText: "Ok"
            });
            this.setState({ loading: false });
            return false;
        }
    
        const descriptionsResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId,
            'payment_descriptions',
            { payment_descriptions: { ...descriptions } }
        );
    
        if (descriptionsResponse.getErrors([]).length > 0) {
            alert({
                text: descriptionsResponse.getErrors()[0],
                buttonText: "Ok"
            });
            this.setState({ loading: false });
            return false;
        }
    
        alert({
            text: "Configurações alteradas com sucesso",
            buttonText: "Ok"
        });
    
        this.setState({ loading: false });
        return true;
    }
    
    render() {
        const { loading, online_payment, payment_on_delivery, descriptions,methodPayment } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer visible={visible} onClose={onClose} closeInFade title="Pagamentos" >
                <div className={styles.secretDrawerContainer}>
                    <div className={styles.container}>
                        <Checkbox
                            name={`online_payment`}
                            design="two"
                            checked={online_payment}
                            onChange={(value) => this.setState({ online_payment: value })}
                        >
                            Pagamento online
                        </Checkbox>
                        <Checkbox
                            name={`payment_on_delivery`}
                            design="two"
                            checked={payment_on_delivery}
                            onChange={(value) => this.setState({ payment_on_delivery: value })}
                        >
                            Pagamento na entrega
                        </Checkbox>
                    </div>
                    <div className={styles.container}>
                    {Object.entries(PaymentMethods).map(([field, name]) => (
                            <div key={field}>
                                <div className={styles.title}>
                                    <Checkbox
                                        name={`methodPayment[${field}]`}
                                        design="two"
                                        checked={!!methodPayment[field]}
                                        onChange={() => this.togglePaymentMethod(field)}
                                    >
                                        {name}
                                    </Checkbox>
                                </div>
                                <Textarea
                                    id="desc"
                                    design="two"
                                    placeholder="Descrição"
                                    className="mb-10"
                                    onChange={(e) => {
                                        this.updateDescription(field, e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        this.updateDescription(field, e.target.value);
                                    }}
                                    defaultValue={descriptions[field]}
                                />
                            </div>
                        ))}
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.save()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
